;(function($) {
  $(function() {

    const floorPlanRequestParams = {
      'search_type': 'floorplan',
      'latest_date': ''  
    };
    
    const toUSD = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
    });
    
    const updateFloorPlanCards = function(allYardiFPData) {
      $('.pwfd-floor-plan').each((index, floorPlan) => {
        const $fp = $(floorPlan);
        const fpId = $fp.data('yardi-id');
        const fpApiData = allYardiFPData[fpId];
        let availabilityText = ""; 
        let isUrgent = false;
        if (apiOptions.availability_text_options !== 'none') {
          const numAvailable = parseInt(fpApiData.AvailableUnitsCount, 10);
          if (!isNaN(numAvailable)) {
            if (numAvailable == 0) {
              availabilityText = apiOptions.sold_out_text;
            } else if (numAvailable > parseInt(apiOptions.urgency_threshold, 10)) {
              availabilityText = apiOptions.availability_text_template.replace('##', numAvailable);
            } else {
              availabilityText = apiOptions.urgent_text_template.replace('##', numAvailable);
              isUrgent = true;
            }
          }
          if (apiOptions.availability_text_options === 'urgent' && isUrgent) {
            $fp.find('.fp-api-details').append(`<div class='fp-availability-text order-3'>${availabilityText}</div>`);
          } else if (apiOptions.availability_text_options === 'all') {
            $fp.find('.fp-api-details').append(`<div class='fp-availability-text order-3'>${availabilityText}</div>`);
          }
        }
        if (fpApiData.MinimumRent > 0) {
          const fpStartingPrice = toUSD.format(fpApiData.MinimumRent); 
          $fp.find('.fp-api-details').append(`<div class='fp-rate order-3'>Rates Starting at ${fpStartingPrice}</div>`);
        }
		  // 6-10-2026 disabling per client request to use main PMS floor plans url
        // if (fpApiData.AvailabilityURL) {
        //   $fp.find('.application-portal').attr('href',fpApiData.AvailabilityURL);
        // }
      });
    }
    
		function mapYadiApiV2DataToPresidiumSite(apiJSON) {
			// const floorPlansById = resJSON.reduce((floorPlansObject, singleFloorPlan) => {
      //   floorPlansObject[singleFloorPlan.FloorplanId] = singleFloorPlan;
      //   return floorPlansObject;
      // }, {});
			if (!apiJSON) {
				return false;
			}

			const floorPlanCollection = apiJSON.floorplans;
			if (!floorPlanCollection) {
				return false;
			}

			const floorPlansById = floorPlanCollection.reduce((floorPlansObject, singleFloorPlan) => {
        floorPlansObject[singleFloorPlan.floorplanId] = {
					"PropertyId": singleFloorPlan.propertyId,
					"FloorplanId": singleFloorPlan.floorplanId,
					"FloorplanName": singleFloorPlan.floorplanName,
					"Beds": singleFloorPlan.beds,
					"Baths": singleFloorPlan.baths,
					"MinimumSQFT": singleFloorPlan.minimumSQFT,
					"MaximumSQFT": singleFloorPlan.maximumSQFT,
					"MinimumRent": singleFloorPlan.minimumRent,
					"MaximumRent": singleFloorPlan.maximumRent,
					"MinimumDeposit": singleFloorPlan.minimumDeposit,
					"MaximumDeposit": singleFloorPlan.maximumDeposit,
					"AvailableUnitsCount": singleFloorPlan.availableUnitsCount,
					"AvailabilityURL": singleFloorPlan.availabilityURL,
					"FloorplanImageURL": singleFloorPlan.floorplanImageURL,
					"FloorplanImageName": singleFloorPlan.floorplanImageName,
					"FloorplanImageAltText": singleFloorPlan.floorplanImageAltText,
					"PropertyShowsSpecials": singleFloorPlan.propertyShowsSpecials,
					"FloorplanHasSpecials": singleFloorPlan.floorplanHasSpecials,
					"UnitTypeMapping": singleFloorPlan.unitTypeMapping,
					"floorplanImageURLArray": singleFloorPlan.floorplanImageURLArray,
					"minimumSQM": singleFloorPlan.minimumSQM,
					"maximumSQM": singleFloorPlan.maximumSQM,
					"floorplanVirtualTourUrl": singleFloorPlan.floorplanVirtualTourUrl,
					"propertyVideoEmbedCode": singleFloorPlan.propertyVideoEmbedCode,
					"tour360EmbedCode": singleFloorPlan.tour360EmbedCode,
					"fpVideoEmbedCode": singleFloorPlan.fpVideoEmbedCode
				};
        return floorPlansObject;
      }, {});
			
			return floorPlansById;
		}
    
    $.ajax({
      url: `/wp-json/presidium-yardi/available-units`,
      method: 'POST',
      dataType: 'json',
      // data: JSON.stringify(floorPlanRequestParams),
      processData: false
    }).done((resJSON, textStatus, jqXHR) => {
			console.log("Rest API Status Code: " + jqXHR.status);
			console.log('Floor plans:', resJSON.floorplans);
			const floorPlansById = mapYadiApiV2DataToPresidiumSite(resJSON);

      updateFloorPlanCards(floorPlansById);
    }).fail((req, status, err) => {
      console.log('Error: ', err);
      console.log('Status: ', status);
    });        
      
  });
})(jQuery)
